// WCAG 2.1 contrast. Partner palettes come from Admin, so a colour painted against
// them has to be derived from the values received rather than assumed legible.

const toRgb = (hex) => {
  const match = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(String(hex).trim())
  if (!match) return null
  const full = match[1].length === 3 ? [...match[1]].map((c) => c + c).join('') : match[1]
  return [0, 2, 4].map((i) => parseInt(full.slice(i, i + 2), 16))
}

const luminance = (rgb) => {
  const [r, g, b] = rgb.map((v) => {
    const s = v / 255
    return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4
  })
  return 0.2126 * r + 0.7152 * g + 0.0722 * b
}

// The mid gray is there for palettes where black and white each disappear into
// one surface -- the default black Primary on a white Background, for one.
const FOCUS_CANDIDATES = ['#000000', '#ffffff', '#767676']

// Of the candidates, the one whose worst contrast across all the surfaces is highest.
// Surfaces that don't parse are skipped, so one bad branding value can't cost the ring.
export const pickFocusColor = (surfaces) => {
  const surfaceLuminances = surfaces.map(toRgb).filter(Boolean).map(luminance)
  const worstRatio = (candidate) => {
    const l = luminance(toRgb(candidate))
    return Math.min(...surfaceLuminances.map((s) => (Math.max(l, s) + 0.05) / (Math.min(l, s) + 0.05)))
  }
  return FOCUS_CANDIDATES.reduce((best, c) => (worstRatio(c) > worstRatio(best) ? c : best))
}
